import { render } from "./AuthorizedContact.vue?vue&type=template&id=a862855a"
import script from "./AuthorizedContact.ts?vue&type=script&lang=js&external"
export * from "./AuthorizedContact.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__